import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import MainEnergyTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import mainEnergyIcon from "../../../../../assets/design-revamp-company/category-icons/purchased_energy_icon.svg";

const MainEnergyContents = ({ businessId, systemBoundaryProps }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="component-energy-contents">
      <SubHeaderBox
        subTitle={t("MAINS_INPUT")}
        scope={"Scope 2"}
        subDescription={t("DESC_MAINS")}
        isNormal={true}
        number={"2.1"}
        systemBoundaryProps={systemBoundaryProps}
        showSystemBoundary={true}
        icon={mainEnergyIcon}
      />
      {showTable && <MainEnergyTable businessId={businessId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default MainEnergyContents;
